import { Lock, RotateCcw, ShieldCheck, MapPin } from "lucide-react";
import { Countdown } from "./Countdown";
import { PriceBlock } from "./PriceBlock";
import { OrderForm } from "./OrderForm";
import { ProductGallery } from "./ProductGallery";
import { useProduct } from "@/lib/product";

const REASSURE = [
  [Lock, "Paiement sécurisé Stripe"],
  [RotateCcw, "Rétractation 14 jours"],
  [ShieldCheck, "Garantie légale 2 ans"],
  [MapPin, "Vendeur basé à Paris"],
];

export const Order = () => {
  const { product } = useProduct();
  return (
    <section id="commander" data-testid="order-section" className="section bg-ice-soft">
      <div className="container-x">
        <div className="order-card grid lg:grid-cols-[0.85fr_1.15fr]">
          <div className="p-6 sm:p-10 lg:p-12 flex flex-col gap-6 bg-gradient-to-b from-sky-50/70 to-white border-b lg:border-b-0 lg:border-r border-slate-200">
            <ProductGallery />
            <div className="flex flex-col gap-3">
              {product?.promo_active && <span className="badge-heat self-start">Offre de déstockage</span>}
              <h2 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">Commandez votre Midea PortaSplit</h2>
              <p className="text-slate-600">Climatiseur split mobile réversible 12 000 BTU — MMCS-12HRN8-QRD0. Kit fenêtre inclus.</p>
            </div>
            <PriceBlock prefix="order" size="md" />
            {product?.promo_active && (
              <div className="flex flex-col gap-2">
                <span className="text-xs font-bold uppercase tracking-[0.18em] text-orange-600">Fin de l'offre dans</span>
                <Countdown prefix="order" />
              </div>
            )}
            <div className="grid grid-cols-2 gap-3 pt-2">
              {REASSURE.map(([Icon, label]) => (
                <span key={label} className="flex items-center gap-2 text-sm text-slate-600">
                  <Icon className="w-4 h-4 text-sky-600 shrink-0" /> {label}
                </span>
              ))}
            </div>
          </div>
          <div className="p-6 sm:p-10 lg:p-12">
            <OrderForm />
          </div>
        </div>
      </div>
    </section>
  );
};
